// Human "working" labels for the copilot's in-flight tool calls (SILL-459).
// The store tracks the running tool's name (currentToolName); this maps it to a
// short present-tense phrase so the dock says "Drafting your message…" instead
// of a generic spinner or a wrong hardcoded line. Unknown/absent → a soft
// default so a new tool never shows a raw snake_case name.
//
// Person Model Completion M3: the retired dual-vocabulary read/mutation/
// draft tool names are replaced by the People model's contact_id-keyed
// names — there is one kind of record: a person.
const TOOL_WORKING_LABELS: Record<string, string> = {
  list_people: "Looking through your people",
  get_person: "Pulling up the person",
  list_book_activity: "Scanning recent activity",
  get_today_queue: "Checking your Today queue",
  list_campaigns: "Reviewing your campaigns",
  get_campaign_results: "Checking campaign results",
  preview_campaign_audience: "Previewing the audience",
  list_templates: "Reviewing your templates",
  search_knowledge: "Searching guidance",
  save_person_note: "Saving your note",
  update_person: "Updating the person",
  create_task: "Creating a task",
  complete_task: "Completing the task",
  create_person: "Adding the person",
  triage_today_item: "Clearing your Today item",
  draft_message: "Drafting your message",
  draft_campaign: "Drafting your campaign",
  prepare_invites: "Preparing invites",
};

/**
 * Working label for the copilot thinking state. Empty `toolName` (no tool
 * running yet — awaiting the first token) reads as "Thinking"; a running tool
 * gets its phrase, falling back to a generic "Working" for an unmapped name.
 */
export function copilotWorkingLabel(toolName: string): string {
  if (!toolName) return "Thinking";
  return TOOL_WORKING_LABELS[toolName] ?? "Working";
}
